import React from 'react'

import { Icon } from 'src/components/ui'

import styles from './MenuIcon.module.scss'

const MenuIcon = ({ name }: { name: string }) => {
  return (
    <div className={styles.menuIcon}>
      <Icon name={name} />
    </div>
  )
}

export default MenuIcon
